<template>
  <v-card :loading="loading">
    <v-card-title>
      <span class="headline">Sierra Chart API key</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-layout v-if="apikey === null" justify-center>
              <v-btn type="submit" large color="success" class="mt-3" @click="create">
                <v-icon>add_circle_outline</v-icon>
                <span>Generate</span>
              </v-btn>
            </v-layout>
            <v-layout v-else justify-center>{{apikey}}</v-layout>

            <div class="errors">
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn disabled v-if="apikey != null" color="blue darken-1" text @click="info">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn v-if="apikey != null" color="blue darken-1" text @click="remove">
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn v-if="apikey != null" color="blue darken-1" text @click="create">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn v-if="apikey != null" color="blue darken-1" text @click="close">
        <v-icon>visibility_off</v-icon>
      </v-btn>
      <v-btn v-if="apikey == null" color="blue darken-1" text @click="close">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "createSierraChartKey",
      errors: new Array(),

      loading: false
    };
  },
  computed: {
    apikey() {
      return this.$store.getters.apiSierraChart;
    }
  },
  methods: {
    close() {
      this.errors = [];
      this.$emit("close", this.name);
    },
    info() {
      this.errors = [];
      this.$emit("close", this.name);
    },
    create() {
      this.errors = [];

      this.loading = true;
      this.$store
        .dispatch("updateApi", {
          type: "create"
        })
        .then(() => {
          //this.apikey = result.data.api
          this.loading = false;
          //this.$emit("close", this.name);
          //this.username = this.$store.getters.username
        })
        .catch(() => {
          this.errors.push("Error");
          this.loading = false;
        });
    },
    remove() {
      this.errors = [];

      this.loading = true;
      this.$store
        .dispatch("updateApi", {
          type: "remove"
        })
        .then(() => {
          //this.apikey = result.data.api
          this.loading = false;
          //this.$emit("close", this.name);
          //this.username = this.$store.getters.username
        })
        .catch(() => {
          this.errors.push("Error");
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>